<template>
  <section class="contact d-flex align-center text-white">
    <div class="content">
      <div>
        <h2 class="big-title big-title--no-p">لنتعرف</h2>
        <p>
          <moving-words>
            لا تتردد بالتواصل معنا سواء كنت مهتما بالعمل معنا، شرب كوب من القهوة، التحدث عن الأفلام أو حتى إلقاء التحية.
          </moving-words>
        </p>
        <a class="btn btn--outline btn--white">
          تواصل معنى الآن
        </a>
      </div>
      <div class="contact-info">
        <div>
          <h6>العنوان</h6>
          <p>عين الكرش - بناء فلان الفلاني</p>
        </div>
        <div>
          <h6>الهاتف</h6>
          <p><a href="tel:963994782499">963-994782499</a></p>
        </div>
        <div>
          <h6>البريد الإلكتروني</h6>
          <p><a href="mailto:info@simahagency.com">info@simahagency.com</a></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MovingWords from '@/components/MovingWords'

export default {
  components: {
    MovingWords
  },
  mounted () {
    document.querySelector('body').style.backgroundColor = '#441a46'
    document.querySelector('.logo').style.filter = 'brightness(0) invert(1)'
    document.querySelector('.hamburger').style.filter = 'brightness(0) invert(1)'
  },
  beforeRouteLeave (to, from, next) {
    document.querySelector('.logo').style.filter = ''
    document.querySelector('.hamburger').style.filter = ''
    document.querySelector('body').style.backgroundColor = '#dfdfdf'
    next()
  }
}
</script>

<style lang="scss" scoped>
.contact > .content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;

  .contact-info {
    @media screen and (min-width: 960px) {
      justify-self: center;
      align-self: flex-end;
      margin-top: 0;
    }
  }
}
</style>
